// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BudgetController from "./budget_controller"
application.register("budget", BudgetController)

import AdminChartsController from "./admin_charts_controller"
application.register("admin-charts", AdminChartsController)

import AttendanceQrScannerController from "./attendance_qr_scanner_controller"
application.register("attendance-qr-scanner", AttendanceQrScannerController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import EditPlanSettingsController from "./edit_plan_settings_controller"
application.register("edit-plan-settings", EditPlanSettingsController)

import ExportController from "./export_controller"
application.register("export", ExportController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import InterestsController from "./interests_controller"
application.register("interests", InterestsController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PlanStatusGuardController from "./plan_status_guard_controller"
application.register("plan-status-guard", PlanStatusGuardController)

import PlanOnboardingController from "./plan_onboarding_controller"
application.register("plan-onboarding", PlanOnboardingController)

import RegistrationWizardController from "./registration_wizard_controller"
application.register("registration-wizard", RegistrationWizardController)

import RequirementsController from "./requirements_controller"
application.register("requirements", RequirementsController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ScrollHintController from "./scroll_hint_controller"
application.register("scroll-hint", ScrollHintController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
